import { Stack } from '@mui/material';
import { DataGrid, DataGridProps } from '@mui/x-data-grid';
import { ILoanResponse } from '@patient-fi/fed-types';

import { getColumnName } from '../../../../../../utilities/getColumnName';
import { getLoanStatusColor } from '../../../../../../utilities/getLoanStatusColor';
import { renderAmountCell } from '../../../../../DataGrid/Cell/AmountCell';
import ChipCell from '../../../../../DataGrid/Cell/ChipCell';
import { renderDateCell } from '../../../../../DataGrid/Cell/DateCell';
import LinkCell from '../../../../../DataGrid/Cell/LinkCell';

interface BorrowerListProps {
  data: ILoanResponse[];
  gridProps?: Partial<DataGridProps>;
}

function LoansList({ data, gridProps }: BorrowerListProps) {
  const columns: DataGridProps<ILoanResponse>['columns'] = [
    {
      field: 'accountId',
      headerName: getColumnName('accountId'),
      minWidth: 100,
      renderCell: ({ value }) => <LinkCell href={`/loans/${value}`}>{value}</LinkCell>,
    },
    {
      field: 'fullNameCustomer',
      headerName: getColumnName('fullNameCustomer'),
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'status',
      headerName: getColumnName('status'),
      flex: 1,
      minWidth: 150,
      renderCell: ({ value }) => <ChipCell value={{ color: getLoanStatusColor(value), label: value }} />,
    },
    {
      field: 'loanAmount',
      headerName: getColumnName('loanAmount'),
      flex: 1,
      minWidth: 150,
      renderCell: renderAmountCell,
    },
    {
      field: 'requestedDate',
      headerName: getColumnName('requestedDate'),
      flex: 1,
      minWidth: 150,
      renderCell: renderDateCell,
    },
    {
      field: 'plan',
      headerName: getColumnName('plan'),
      minWidth: 150,
    },
  ];

  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      <DataGrid<ILoanResponse>
        getRowId={(row) => row._id}
        rows={data}
        columns={columns}
        pageSize={10}
        rowCount={data.length}
        {...gridProps}
      />
    </Stack>
  );
}

export default LoansList;
